const deletePaymentToken = `
    mutation DeletePaymentToken($public_hash: String!) {
        deletePaymentToken(public_hash: $public_hash) {
            customerPaymentTokens { 
                items {
                    details    
                    public_hash
                    payment_method_code
                    type
                }
            }
        }
    }
`;

export default {
    deletePaymentToken,
}
